import { useAppStore } from "../../context/state";

function ProtectedAccess({ element, children, role=[], ...props }) {
  const user = useAppStore((state) => state.user);
  // Any 
  if(!user && role.includes('any')) return element
  // Validate user
  if(!user) return null;
  // User role is into roles allowed 
  if(user.role && !role.includes(user.role) ) return null;
  // We return a Route component that gets added to our list of routes
  return element
}

export default ProtectedAccess;